import React from 'react'

import ChangeUserButton from './ChangeUser/ChangeUserButton'

const NormalState = ({
  customer,
  openEditForm,
  onCopyEmailToClipboard,
  onCopyWebsiteToClipboard,
}) => {
  const avatarUrl = customer.avatarUrl
  const actorInitials = customer.initials
  const avatarStyles = { backgroundImage: `url(${avatarUrl})` }
  return (
    <div className="card customer">
      <div className="avatar" style={avatarStyles}>
        {!avatarUrl && actorInitials}
      </div>
      <div className="header">{customer.labelFull}</div>
      {customer.about && <div className="about">{`“${customer.about}”`}</div>}
      <div className="section">
        <span className="Icon Icon-account-circle" />
        <a className="text" href={`mailto:${customer.email}`}>
          {customer.email}
        </a>
        <span
          onClick={onCopyEmailToClipboard}
          className="Icon Icon-copy-clipboard"
        />
      </div>
      {customer.website_url && (
        <div className="section">
          <span className="Icon Icon-language" />
          <a
            className="text"
            href={customer.website_url}
            rel="noopener noreferrer"
            target="_blank"
          >
            {customer.website_url}
          </a>
          <span
            onClick={onCopyWebsiteToClipboard}
            className="Icon Icon-copy-clipboard"
          />
        </div>
      )}
      {customer.company_name && (
        <div className="section">
          <span className="Icon Icon-copyright" />
          <span className="text">{customer.company_name}</span>
        </div>
      )}
      {customer.phone_number && (
        <div className="section">
          <span className="Icon Icon-phone" />
          <span className="text">{customer.phone_number}</span>
        </div>
      )}
      {customer.location && (
        <div className="section">
          <span className="Icon Icon-place" />
          <span className="text">{customer.location}</span>
        </div>
      )}
      <div className="buttons">
        <button className="ui basic button" onClick={openEditForm}>
          Edit
        </button>
        <ChangeUserButton />
      </div>
    </div>
  )
}

export default NormalState
